export {
    type TrustpilotProps,
    TrustpilotWidgetVariant,
} from "./Trustpilot.types";
export * from "./Trustpilot";
